import type { BlockSectionBg } from "./common/types";

export type ClientsTheme = {
  headline: string;
  bodyText: string;
  tagVariant: "default" | "onTinted";
  toggleLink: string;
  logoImageClass: string;
};

/** Figma block_partners 2462:1904 — lite, grey (muted), dark. */
const clientsThemeMap: Record<BlockSectionBg, ClientsTheme> = {
  light: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    toggleLink: "text-foreground hover:text-primary",
    logoImageClass: "grayscale hover:grayscale-0",
  },
  default: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    toggleLink: "text-foreground hover:text-primary",
    logoImageClass: "grayscale hover:grayscale-0",
  },
  muted: {
    headline: "text-foreground",
    bodyText: "text-tag-foreground",
    tagVariant: "default",
    toggleLink: "text-foreground hover:text-primary",
    logoImageClass: "grayscale hover:grayscale-0",
  },
  dark: {
    headline: "text-secondary-foreground",
    bodyText: "text-header-top-fg",
    tagVariant: "onTinted",
    toggleLink: "text-secondary-foreground hover:text-primary-foreground",
    logoImageClass: "brightness-0 invert hover:filter-none",
  },
  red: {
    headline: "text-primary-foreground",
    bodyText: "text-header-top-fg",
    tagVariant: "onTinted",
    toggleLink: "text-primary-foreground hover:text-header-top-fg",
    logoImageClass: "brightness-0 invert hover:filter-none",
  },
};

export function resolveClientsTheme(sectionBg: BlockSectionBg): ClientsTheme {
  return clientsThemeMap[sectionBg] ?? clientsThemeMap.light;
}
